// src/services/pushTokenService.js
//
// PRD-022 INC-2 — registro/revogação do token de push e disparo do push de teste.
// Tudo via requestWithAuth (Bearer + refresh; nunca fetch cru). O core-api expõe
// (RoutePrefixConvention `/api/core/v1/`):
//   POST   /core/v1/notifications/token   { token }   → vincula o token ao usuário
//   DELETE /core/v1/notifications/token   { token }   → desvincula
//   POST   /core/v1/notifications/test                → push de teste p/ o próprio usuário
//
// O device_type é derivado server-side do header PTM-Platform (=Web) — não vai no body.
import { requestWithAuth } from "./api";

const BASE = "/core/v1/notifications";

/** Vincula o token FCM-web ao usuário logado. */
export async function registerWebPushToken(token) {
  const response = await requestWithAuth(`${BASE}/token`, {
    method: "POST",
    body: JSON.stringify({ token }),
  });
  if (!response || !response.ok) {
    throw new Error(`Falha ao registrar token de push (${response?.status ?? "sem resposta"})`);
  }
  return true;
}

/** Desvincula o token FCM-web do usuário logado. */
export async function unregisterWebPushToken(token) {
  const response = await requestWithAuth(`${BASE}/token`, {
    method: "DELETE",
    body: JSON.stringify({ token }),
  });
  if (!response || !response.ok) {
    throw new Error(`Falha ao remover token de push (${response?.status ?? "sem resposta"})`);
  }
  return true;
}

/**
 * Dispara um push de teste para os próprios dispositivos do usuário logado.
 * Restrito a GeneralAdmin server-side (403) — 404 quando não há token registrado.
 * @returns {Promise<{sent:number}>}
 */
export async function sendTestPush() {
  const response = await requestWithAuth(`${BASE}/test`, { method: "POST" });
  if (!response || !response.ok) {
    if (response?.status === 404) {
      const err = new Error("Nenhum dispositivo registrado. Ative as notificações primeiro.");
      err.code = "NO_TOKEN";
      throw err;
    }
    if (response?.status === 403) {
      const err = new Error("Sem permissão para enviar push de teste.");
      err.code = "FORBIDDEN";
      throw err;
    }
    throw new Error(`Falha ao enviar push de teste (${response?.status ?? "sem resposta"})`);
  }
  return response.json().catch(() => ({}));
}
